import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import ContextTag from '../../../../../../Common/ContextTag';
import { CommandContextFieldsFragment } from '../../../../../../generated/core-api/graphql-react-query';
import useSessionContext from '../../../../../LiveContext/SessionContextProvider/useSessionContext';

interface ContextSelectorMenuProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  contexts: CommandContextFieldsFragment[];
}

export default function ContextSelectorMenu(props: ContextSelectorMenuProps) {
  const { anchorEl, setAnchorEl, contexts } = props;
  const { context, setContext } = useSessionContext();

  return (
    <Menu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={() => { setAnchorEl(null); }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {contexts.map((value) => (
        <MenuItem
          key={value.textLower}
          onClick={() => {
            setContext(value.textLower);
            setAnchorEl(null);
          }}
          selected={context === value.textLower}
        >
          <ContextTag context={value} />
        </MenuItem>
      ))}
    </Menu>

  );
}
